export const Directions = [
  { name: 'plans', path: '/subscription-management/plans' },
  {
    name: 'paymentMethods',
    path: '/subscription-management/payment-methods',
  },
];
